import React from "react";
import useTheme from "../../hooks/useTheme";

interface RectangleProps {
  childrean?: React.ReactNode;
  width?: number | string;
  height?: number | string;
  color?: string;
}

const Rectangle: React.FC<RectangleProps> = ({
  width = 137,
  height = 16,
  color,
}) => {
  const { theme } = useTheme();
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 137 16`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <path
        d="M127 16L137 0H10L0 16H127Z"
        fill={color ?? theme.colors.primary}
      />
    </svg>
  );
};

export default Rectangle;
